"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformUrl = exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const transformRequest = (data, headers) => {
  // in case we have formdata meaning multipart form request set it properly.
  if (data && data.formData) {
    return data.formData;
  } else {
    return JSON.stringify(data);
  }
};
const transformResponse = (data, headers) => {
  return data;
};
const transformUrl = apiCall => {
  let {
    url
  } = apiCall;
  const urlFrags = url.split('/');
  urlFrags.forEach(frg => {
    if (frg.startsWith(':')) {
      if (!apiCall.data[frg.substring(1, frg.length)]) {
        throw new Error(`Data not found ${frg.substring(1, frg.length)}`);
      }
      url = url.replace(frg, apiCall.data[frg.substring(1, frg.length)]);
    }
  });
  if (apiCall.query) {
    url = `${url}?${apiCall.query}`;
  }
  apiCall.url = url;
};
exports.transformUrl = transformUrl;
const defaultOptions = {
  baseURL: '/',
  headers: {
    'x-nile-client': 'cleo',
    post: {
      'Content-Type': 'application/json'
    },
    put: {
      'Content-Type': 'application/json'
    },
    patch: {
      'Content-Type': 'application/json'
    }
  },
  transformRequest: [transformRequest],
  transformResponse: [transformResponse],
  timeout: 10000,
  responseType: 'json',
  // `responseEncoding` indicates encoding to use for decoding responses
  // Note: Ignored for `responseType` of 'stream' or client-side requests
  responseEncoding: 'utf8',
  // `xsrfCookieName` is the name of the cookie to use as a value for xsrf token
  xsrfCookieName: 'XSRF-TOKEN',
  // `xsrfHeaderName` is the name of the http header that carries the xsrf token value
  xsrfHeaderName: 'X-XSRF-TOKEN' // default
};

const axiosXhr = options => _axios.default.create({
  ...defaultOptions,
  ...options
});

/**
 * @param {object} options Valid axios options per https://github.com/axios/axios
 */
const getAxiosXhr = (options = {}) => {
  return axiosXhr(options);
};
var _default = getAxiosXhr;
exports.default = _default;